import React from 'react'

const BasicInput = ({ id, label, name, onChange, onKeyDown, type, value, placeholder, icon, className, required, min, max, error, touched }) => {
    return (
        <>
            <div className={`input-wrapper ${className ? className : ''}`}>
                <label htmlFor={id} className={`input input-sm border-base-300 border-solid border flex items-center gap-2 transition-all duration-200  bg-white focus-within:border-primary focus-within:shadow-primary/30 focus-within:shadow-md outline-none focus-within:outline-none focus-visible:outline-none`}>
                    {label && <span className='flex-shrink-0 flex-grow-0 font-medium'>{label}</span>}
                    <input
                        id={id}
                        name={name}
                        required={required}
                        type={type}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        value={value || ''}
                        className={`grow w-full h-full p-2 focus:outline-none ${label ? 'border-l border-solid border-gray-300 border-y-0 border-r-0 pl-2' : ''}`}
                        placeholder={placeholder}
                        {...(min && type === 'number' ? { min } : {})}
                        {...(max && type === 'number' ? { max } : {})}
                    />
                    {icon && icon}
                </label>
            </div>
            {error && touched && <div className="error-message text-red-500 text-sm mt-1">{error}</div>}
        </>
    )
}

export default BasicInput
